import { fetchAuthSession } from "aws-amplify/auth";
import { environment } from "./environments/environment";

const awsConf = {
  API: {
    REST: {
      [environment.awsAPIEndpointName]: {
        endpoint: environment.awsAPIEndpointUrl,
      },
    },
  },
  Auth: {
    Cognito: {
      identityPoolId: environment.awsCognitoIdentityPool, // Amazon Cognito User Pool ID
      userPoolId: environment.awsUserPoolsId, //REQUIRED - Amazon Cognito User Pool ID
      userPoolClientId: environment.awsUserPoolClientId, //REQUIRED - Amazon Cognito Web Client ID
      loginWith: {
        // OPTIONAL
        oauth: {
          domain: environment.awsOauthDomain,
          scopes: environment.awsOauthScope,
          redirectSignIn: environment.awsOauthRedirectSignIn,
          redirectSignOut: environment.awsOauthredirectSignOut,
          responseType: environment.awsOauthResponseType,
        },
        username: true,
        email: true, // OPTIONAL
        phone: false, // OPTIONAL
      },
    },
  },
  Storage: {
    S3: {
      bucket: environment.awsMediaS3Bucket, //OPTIONAL -  Amazon S3 bucket name
      region: environment.awsMediaS3BucketRegion, //OPTIONAL -  Amazon service region
    },
  },
};

export const awsApiAuthorization = {
  API: {
    REST: {
      headers: async () => {
        return {
          Authorization: `Bearer ${(
            await fetchAuthSession()
          ).tokens?.idToken?.toString()}`,
        };
      },
    },
  },
};

export default awsConf;
